var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _vm.isMy
            ? _c(
                "el-row",
                { staticStyle: { margin: "5px 0" } },
                [
                  _vm.rmcProteinFeedFactoryId === "0" &&
                  (!_vm.detailForm.auditStatus ||
                    _vm.detailForm.auditStatus === "Draft") &&
                  (_vm.ms_roles.indexOf("QSPI_RMC_CHICK_SPONS_SUPP") !== -1 ||
                    _vm.ms_roles.indexOf("QSPI_RMC_PORK_SPONS_SUPP") !== -1)
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.RMC_PROT_FEEDPLANT_SAVE,
                              expression: "RMC_PROT_FEEDPLANT_SAVE",
                            },
                          ],
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onAddSave },
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                  _vm.rmcProteinFeedFactoryId !== "0" &&
                  (!_vm.detailForm.auditStatus ||
                    _vm.detailForm.auditStatus === "Draft") &&
                  (_vm.ms_roles.indexOf("QSPI_RMC_CHICK_SPONS_SUPP") !== -1 ||
                    _vm.ms_roles.indexOf("QSPI_RMC_PORK_SPONS_SUPP") !== -1)
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.RMC_PROT_FEEDPLANT_SAVE,
                              expression: "RMC_PROT_FEEDPLANT_SAVE",
                            },
                          ],
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onEditSave },
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                  _vm.detailForm.auditStatus !== "PendingApproval" &&
                  (_vm.ms_roles.indexOf("QSPI_RMC_CHICK_SPONS_SUPP") !== -1 ||
                    _vm.ms_roles.indexOf("QSPI_RMC_PORK_SPONS_SUPP") !== -1)
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.RMC_PROT_FEEDPLANT_SUBMIT,
                              expression: "RMC_PROT_FEEDPLANT_SUBMIT",
                            },
                          ],
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("提交")]
                      )
                    : _vm._e(),
                  _vm.detailForm.auditStatus === "PendingApproval" &&
                  _vm.ms_roles.indexOf("QSPI_RMC_PROTEIN_CQS") !== -1
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.RMC_PROT_FEEDPLANT_APPROVE,
                              expression: "RMC_PROT_FEEDPLANT_APPROVE",
                            },
                          ],
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onApprove },
                        },
                        [_vm._v("批准")]
                      )
                    : _vm._e(),
                  _vm.detailForm.auditStatus === "PendingApproval" &&
                  _vm.ms_roles.indexOf("QSPI_RMC_PROTEIN_CQS") !== -1
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.RMC_PROT_FEEDPLANT_RETURN,
                              expression: "RMC_PROT_FEEDPLANT_RETURN",
                            },
                          ],
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onReturn },
                        },
                        [_vm._v("退回")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "detailForm",
              attrs: { model: _vm.detailForm, "label-width": "120px" },
            },
            [
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [_vm._v("饲料厂清单")]),
                ]),
                _c(
                  "div",
                  { staticClass: "form_box" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Category3",
                                  prop: "category3Code",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled:
                                        _vm.isDisabled || _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.category3Code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "category3Code",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.category3Code",
                                    },
                                  },
                                  _vm._l(
                                    _vm.category3CodeOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Sponsor",
                                  prop: "sponsorName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.sponsorName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "sponsorName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.sponsorName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "ASL Group",
                                  prop: "aslGroupCode",
                                  rules: _vm.rules.aslGroupCode,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      disabled: _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.aslGroupCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "aslGroupCode",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.aslGroupCode",
                                    },
                                  },
                                  _vm._l(
                                    _vm.aslGroupCodeOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.aslGroupName,
                                          value: item.aslGroupCode,
                                          disabled: !item.enabled,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态", prop: "auditStatus" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.auditStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "auditStatus",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.auditStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.auditStatusOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "饲料厂名称",
                                  prop: "feedFactoryName",
                                  rules: _vm.rules.feedFactoryName,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.feedFactoryName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "feedFactoryName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.feedFactoryName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "地址",
                                  prop: "feedFactoryAddress",
                                  rules: _vm.rules.feedFactoryAddress,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.feedFactoryAddress,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "feedFactoryAddress",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.feedFactoryAddress",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "饲料厂属性",
                                  prop: "feedFactoryNature",
                                  rules: _vm.rules.feedFactoryNature,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isForbidden,
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.feedFactoryNature,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "feedFactoryNature",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "detailForm.feedFactoryNature",
                                    },
                                  },
                                  _vm._l(
                                    _vm.feedFactoryNatureOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "饲料厂状态",
                                  prop: "factoryStatus",
                                  rules: _vm.rules.factoryStatus,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isForbidden,
                                      clearable: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.factoryStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "factoryStatus",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.factoryStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.factoryStatusOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "审核标准",
                                  prop: "auditStandard",
                                  rules: _vm.rules.auditStandard,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.auditStandard,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "auditStandard",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.auditStandard",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.$route.query.from === "edit"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "上次修改原因",
                                      prop: "lastUpdateReason",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: "",
                                        type: "textarea",
                                        maxlength: "1000",
                                        "show-word-limit": "",
                                        autosize: { minRows: 4, maxRows: 6 },
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: _vm.lastUpdateReason,
                                        callback: function ($$v) {
                                          _vm.lastUpdateReason = $$v
                                        },
                                        expression: "lastUpdateReason",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "修改原因",
                                  prop: "updateReason",
                                  rules: _vm.rules.updateReason,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.updateReason,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "updateReason",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.updateReason",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            title: "退回意见",
            visible: _vm.dialogReturnVisible,
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogReturnVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "returnForm",
              attrs: { model: _vm.returnForm, rules: _vm.returnFormRules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "returnedReason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "1000",
                      "show-word-limit": "",
                      autosize: { minRows: 4, maxRows: 6 },
                      placeholder: "请输入内容",
                    },
                    model: {
                      value: _vm.returnForm.returnedReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.returnForm, "returnedReason", $$v)
                      },
                      expression: "returnForm.returnedReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.onClose } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }